import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { IEnvironment } from 'app/projects/core/src/lib/interfaces/environment.interface';
import { MAXBRAIN_ENVIRONMENT } from 'app/projects/core/src/lib/services/environment.token';
import { map } from 'rxjs/operators';
import { IExperienceAlumniWidgetContentQuery } from '../interfaces/experience-alumni-widget-content.interface';
import { IExperienceConfigQuery } from '../interfaces/experience-config.interface';
import { IExperienceWidgetContentQuery } from '../interfaces/experience-widget-content.interface';
import { IHeaderBannerContentPreviewQuery } from '../interfaces/header-banner-conent-preview.query.interface';
import { IStudentWidgetContentQuery } from '../interfaces/student-widget-content.interface';
import { ExperienceAlumniWidgetContent } from '../models/experience-alumni-widget-content.model';
import { ExperienceConfig } from '../models/experience-config.model';
import { ExperienceWidgetContent } from '../models/experience-widget-content.model';
import { HeaderBannerContentPreview } from '../models/header-banner-content-preview.model';
import { StudentWidgetContent } from '../models/student-widget-content.model';

@Injectable()
export class GrowPreviewApiService {
    constructor(private _http: HttpClient, @Inject(MAXBRAIN_ENVIRONMENT) public environment: IEnvironment) {}

    async getExperienceConfig(id: string): Promise<ExperienceConfig> {
        return this._http
            .get<IExperienceConfigQuery>(`${this.environment.apiUrl}/engage/home-screen/config/preview?experience=${id}`)
            .pipe(map((query) => new ExperienceConfig(query)))
            .toPromise();
    }

    async getHeaderBannerContentPreview(experienceId: string, audiencesIds: string[]): Promise<HeaderBannerContentPreview> {
        return this._http
            .get<IHeaderBannerContentPreviewQuery>(`${this.environment.apiUrl}/engage/home-screen/header-banner/preview?experience=${experienceId}&audiences=${audiencesIds}`)
            .pipe(map((query) => new HeaderBannerContentPreview(query)))
            .toPromise();
    }

    async getExperienceWidgets(id: string, audiencesIds: string[]): Promise<ExperienceWidgetContent> {
        return this._http
            .get<IExperienceWidgetContentQuery>(`${this.environment.apiUrl}/engage/home-screen/widget/${id}/preview?audiences=${audiencesIds}`)
            .pipe(map((query) => new ExperienceWidgetContent(query)))
            .toPromise();
    }

    async getExperienceAlumniWidgets(id: string): Promise<ExperienceAlumniWidgetContent> {
        return this._http
            .get<IExperienceAlumniWidgetContentQuery>(`${this.environment.apiUrl}/engage/home-screen/widget/${id}/preview`)
            .pipe(map((query) => new ExperienceAlumniWidgetContent(query)))
            .toPromise();
    }

    async getStudentWidget(id: string): Promise<StudentWidgetContent> {
        return this._http
            .get<IStudentWidgetContentQuery>(`${this.environment.apiUrl}/engage/home-screen/widget/${id}/preview`)
            .pipe(map((query) => new StudentWidgetContent(query)))
            .toPromise();
    }

    async getExperienceFeaturedWidget(id: string, audiencesIds: string[]): Promise<ExperienceWidgetContent> {
        return this._http
            .get<IExperienceWidgetContentQuery>(`${this.environment.apiUrl}/engage/home-screen/widget/${id}/preview?audiences=${audiencesIds}`)
            .pipe(map((query) => new ExperienceWidgetContent(query)))
            .toPromise();
    }
}
